import {
  ChangeDetectorRef,
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  OnInit,
  OnDestroy,
  OnChanges,
} from '@angular/core';
import { UserService } from '../../../../user/user.service';
import { switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-generate-letter-modal',
  templateUrl: './generate-letter-modal.component.html',
  styleUrls: ['./generate-letter-modal.component.scss'],
})
export class GenerateLetterModalComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isOpen: boolean = false;
  @Input() isPreviewLetter: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() create = new EventEmitter<any>();
  @Output() previewLetter = new EventEmitter<any>();

  selectedOption: string = '';
  selectedUser: any = null;
  selectedUserId: number;
  isUserDropdownOpen: boolean = false;
  selectedAdmin: number;
  adminArray: any = [];
  private subscription: Subscription;

  constructor(
    private userService: UserService,
    private cdr: ChangeDetectorRef,
  ) {}

  async ngOnInit(): Promise<void> {
    this.subscription = this.userService
      .listAdminWithRecletter()
      .pipe(
        switchMap((res: any) => {
          this.adminArray = res;
          return this.userService.profile();
        }),
      )
      .subscribe((currentUser: any) => {
        if (currentUser) {
          const foundUser = this.adminArray.find(u => u.id == currentUser.id);
          if (foundUser) {
            this.selectUser(foundUser);
          }
        }
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnChanges(): void {
    if (this.isOpen) {
      if (!this.selectedUser && !this.selectedUserId) {
        this.resetValues();
      }
    }
  }

  private resetValues(): void {
    this.selectedOption = '';
    this.selectedUser = null;
    this.selectedUserId = null;
    this.isUserDropdownOpen = false;
  }

  toggleUserDropdown(): void {
    this.isUserDropdownOpen = !this.isUserDropdownOpen;
  }

  selectUser(user: any): void {
    this.selectedUser = user.name;
    this.selectedUserId = user.id;
    this.isUserDropdownOpen = false;
  }

  onClose(): void {
    this.close.emit();
  }

  onPreview(): void {
    if (this.isPreviewEnabled && this.selectedUserId) {
      const previewVersionFlag = this.isPreviewLetter || this.selectedOption === 'new';
      this.previewLetter.emit({
        userId: this.selectedUserId,
        previewVersionFlag: previewVersionFlag,
      });
    }
  }

  onProceed(): void {
    if (this.selectedOption && this.selectedUserId) {
      const createVersionFlag = this.selectedOption === 'new';
      this.create.emit({
        userId: this.selectedUserId,
        createVersionFlag: createVersionFlag,
      });

      this.onClose();
    }
  }

  onCancel(): void {
    this.onClose();
  }

  get isProceedEnabled(): boolean {
    return !!(this.selectedOption && this.selectedUserId);
  }

  get isPreviewEnabled(): boolean {
    if (this.isPreviewLetter) {
      return !!this.selectedUserId;
    } else {
      return !!this.selectedUserId && !!this.selectedOption;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    const dropdownElement = target.closest('.user-dropdown');

    if (!dropdownElement && this.isUserDropdownOpen) {
      this.isUserDropdownOpen = false;
    }
  }
}
